import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Badge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { toast } from "sonner";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = async () => {
    const { data } = await api.get("/notifications");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.patch(`/notifications/${id}/read`);
    load();
  };
  const markAll = async () => {
    await api.patch("/notifications/read-all");
    toast.success("Tüm bildirimler okundu olarak işaretlendi");
    load();
  };

  const filtered = filter === "unread" ? items.filter((n) => !n.is_read)
                : filter === "read" ? items.filter((n) => n.is_read)
                : items;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex gap-2">
          {[["all","Tümü"],["unread","Okunmamış"],["read","Okunmuş"]].map(([k,l]) => (
            <button key={k} onClick={() => setFilter(k)}
                    data-testid={`filter-${k}`}
                    className={`px-3 py-1.5 rounded-lg text-xs font-semibold ${
                      filter === k ? "bg-[#0B3676] text-white" : "bg-white text-[#6B7280] border border-[#E5E7EB]"
                    }`}>
              {l}
            </button>
          ))}
        </div>
        <Button onClick={markAll} variant="outline" data-testid="mark-all">
          <Check size={14} className="mr-1" /> Tümünü Okundu Yap
        </Button>
      </div>

      <div className="space-y-2">
        {filtered.length === 0 ? (
          <div className="azd-card p-8 text-center text-[#6B7280]">
            Bildirim bulunmuyor
          </div>
        ) : filtered.map((n) => (
          <div key={n.id}
               data-testid={`notif-${n.id}`}
               className={`azd-card p-4 ${!n.is_read ? "border-l-4 border-l-[#FFE600]" : ""}`}
               onClick={() => !n.is_read && markRead(n.id)}>
            <div className="flex items-start gap-3">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <div className="font-bold text-[#08285A]">{n.title}</div>
                  {!n.is_read && <Badge variant="warning">Yeni</Badge>}
                </div>
                <div className="text-sm text-[#6B7280]">{n.message}</div>
                <div className="text-xs text-[#6B7280] mt-2">{fmtDateTime(n.created_at)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
